// components/PrintButton.js
'use client';

import { useEffect } from 'react';

const PrintButton = () => {
  useEffect(() => {
    const handlePrint = () => window.print();

    const printButton = document.createElement('button');
    printButton.id = 'printButton';
    printButton.innerText = 'Print Page';
    printButton.style.position = 'fixed';
    printButton.style.bottom = '20px';
    printButton.style.right = '120px';
    printButton.style.padding = '10px 15px';
    printButton.style.background = '#262626';
    printButton.style.color = '#fff';
    printButton.style.border = 'none';
    printButton.style.borderRadius = '5px';
    printButton.style.cursor = 'pointer';
    printButton.style.zIndex = '1000';

    printButton.addEventListener('click', handlePrint);
    document.body.appendChild(printButton);

    return () => {
      printButton.removeEventListener('click', handlePrint);
      document.body.removeChild(printButton);
    };
  }, []);

  return null;
};

export default PrintButton;
